// extracted by mini-css-extract-plugin
module.exports = {"root":"Interaction8_root__3Il0d"};